import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const AffiliateVehiclesActions = () => {
  return (
    <div className="mt-2">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
